import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './action';

let table = { ...config };
table.url = '/user';
table.columns = {
  name: {
    title: 'Nama',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div>
          <div className="text-ellipsis fw-semibold">{row?.name}</div>
          <div className="text-muted fs-8">{row?.username}</div>
        </div>
      );
    },
  },
  phone: {
    title: 'Nomor Handphone',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.phone || '-'}</div>;
    },
  },
  type: {
    title: 'Tipe',
    sortable: true,
    alias: 'type',
    width: 150,
    component: (row) => {
      return (
        <div className="text-ellipsis text-capitalize">{row?.type || '-'}</div>
      );
    },
  },
  registered_at: {
    title: 'Terdaftar Pada',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.registered_at, 'DD MMM YYYY - HH:mm')} WIB
        </div>
      );
    },
  },
  last_login_at: {
    title: 'Aktifitas Terakhir',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.last_activity_at !== '0001-01-01T00:00:00Z'
            ? formatDate(row?.last_activity_at, 'DD MMM YYYY - HH:mm') + ' WIB'
            : '-'}
        </div>
      );
    },
  },
  action: {
    title: '',
    sortable: false,
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
